__turbopack_context__.v({
  "card": "program-card-module-scss-module__flFm8q__card",
  "cardTag": "program-card-module-scss-module__flFm8q__cardTag",
  "cardTitle": "program-card-module-scss-module__flFm8q__cardTitle",
  "duration": "program-card-module-scss-module__flFm8q__duration",
  "programIcon": "program-card-module-scss-module__flFm8q__programIcon",
  "rightArrow": "program-card-module-scss-module__flFm8q__rightArrow",
  "sponsoredBy": "program-card-module-scss-module__flFm8q__sponsoredBy",
});
